/* eslint-disable react/prop-types */
import React from 'react';
import dataSuccess from 'data/dataSuccess';
import SuccessPage from 'components/success/SuccessPage';

import { ReactComponent as InfoIcon } from 'images/info-filled.svg';

class SuccessInfo extends React.Component {
  render() {
    const info = dataSuccess[this.props.success].info;
    return (
      <SuccessPage {...this.props} className="desktop:!p-4">
        <div className="min-h-[101px] bg-bleu-hellio-1 flex p-3 gap-2.5 -mx-1 mt-2 desktop:m-0 rounded-lg">
          <InfoIcon className="mt-0.5" />
          <div className="flex-1 text-[14px]/5 gap-2.5 flex flex-col">
            {typeof info === 'function' ? info(this.props) : info}
          </div>
        </div>
      </SuccessPage>
    );
  }
}

export default SuccessInfo;
